import { Outlet, Route, Routes } from 'react-router-dom';
import { BookingScreen } from './BookingScreen';
import { NonExistingScreen } from './NonExistingScreen';
import { AccomodationStep } from './steps/AccomodationStep';
import { EventStep } from './steps/EventStep';
import { FeeStep } from './steps/FeeStep';
import { PromoterStep } from './steps/PromoterStep';
import { StartStep } from './steps/StartStep';
import { SummaryStep } from './steps/SummaryStep';
import { TimesStep } from './steps/TimesStep';
import { TechStep } from './steps/TechStep';

export const BookingRoutes = () => {
	return (
		<Routes>
			<Route path="booking/non-existing" element={<NonExistingScreen />} />

			<Route
				path="booking/:id/*"
				element={
					<BookingScreen>
						<Outlet />
					</BookingScreen>
				}
			>
				<Route index element={<StartStep />} />
				<Route path="event" element={<EventStep />} />
				<Route path="promoter" element={<PromoterStep />} />
				<Route path="tech" element={<TechStep />} />
				<Route path="times" element={<TimesStep />} />
				<Route path="fee" element={<FeeStep />} />
				<Route path="accomodation" element={<AccomodationStep />} />
				<Route path="summary" element={<SummaryStep />} />
			</Route>
		</Routes>
	);
};
